import http from '@/plugins/api'
import {
  startLoading
} from '@/plugins/loading'
import * as types from './types'

export default {
  setSearchTerm({
    commit
  }, text) {
    commit(types.SET_SEARCH_TERM, text)
  },
  setPageSize({
    commit
  }, pageSize) {
    commit(types.SET_PAGE_SIZE, pageSize)
  },
  setSortDir({
    commit
  }, sortDir) {
    commit(types.SET_SORT_DIR, sortDir)
  },
  setOrderBy({
    commit
  }, orderBy) {
    commit(types.SET_ORDER_BY, orderBy)
  },
  setFilterBy({
    commit
  }, filterBy) {
    commit(types.SET_FILTER_BY, filterBy)
  },
  getFilterOptions({
    commit
  }, data) {
    commit(types.SET_FILTER_OPTIONS, data)
  },
  async getTechnician({
    commit,
    dispatch
  }, id) {
    const r = await startLoading(dispatch, 'getTechnician', () =>
      http.get(`TeamQuery/GetTechnician?id=${id}`)
    )
    commit(types.SET_TECHNICIAN, r.data)
  },
  async getTechnicians({
    commit,
    dispatch
  }, options) {
    const r = await startLoading(dispatch, 'getTechnicians', () =>
      http.get(`TeamQuery/GetTechnicians`, {
        params: options
      })
    )
    commit(types.SET_TECHNICIANS, r.data)
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/technicians/actions.js